import { CtaArrow } from "@/components/editorial/cta-arrow";

import { STARTING_PRICES, TEAM_PLAN, TEAM_START } from "./pricing-data";

/**
 * The starting prices the other pages quote, in one sentence, then the way
 * to the pricing page. The home's start band and every solution page's "How
 * you start" say it in these words, so the two ways to buy read the same
 * wherever they are quoted. Both sit beside the two-week activation, so the
 * sentence opens with the other way in: Team, started today.
 */
export function StartingPrices() {
  return (
    <>
      {TEAM_START} on {TEAM_PLAN.name}, from {STARTING_PRICES.team} a user a month on a shared deployment. Core from {STARTING_PRICES.core} a month
      with a dedicated, managed deployment and AI usage from {STARTING_PRICES.credits} a month. Optional engineering at{" "}
      {STARTING_PRICES.engineeringDay} a day.{" "}
      <a href="/pricing" className="whitespace-nowrap underline underline-offset-4">
        See pricing <CtaArrow />
      </a>
    </>
  );
}
